/**
 * Meta (Facebook) Pixel 追蹤參數處理
 *
 * 1. fbp / fbc：從 cookie 取得瀏覽器 ID 與點擊 ID，隨捐款交易傳給後端，
 *    後端 Conversions API (AnalyticsService.php) 會放進 user_data 提高配對品質。
 *    fbc 涵蓋率是 Events Manager 診斷的重點指標。
 * 2. fbclid 補存：SPA 換頁後網址參數會消失，若 Pixel 還沒把 fbclid 寫進 _fbc cookie，
 *    進站時先存起來，之後可自行組出 fbc。
 * 3. 進階配對 (Advanced Matching)：把使用者資料推進 GTM dataLayer，
 *    供 FB Pixel 代碼的進階配對欄位使用（Pixel 會在瀏覽器端雜湊後才傳送）。
 */

const FBCLID_STORAGE_KEY = 'tft_fbclid';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

/**
 * 進站時呼叫：網址帶有 fbclid（從 Meta 廣告點進來）就先存起來
 */
export function captureFbclid() {
  try {
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if(fbclid) {
      localStorage.setItem(FBCLID_STORAGE_KEY, JSON.stringify({
        fbclid,
        ts: Date.now(),
      }));
    }
  } catch(e) { /* localStorage 不可用時略過 */ }
}

/**
 * 取得 fbc（FB Click ID）
 * 優先用 Pixel 寫入的 _fbc cookie；沒有的話用之前存下的 fbclid 依官方格式自行組出
 * 格式：fb.1.<寫入當下毫秒時間戳>.<fbclid>
 */
export function getFbc() {
  const cookie = getCookie('_fbc');
  if(cookie) return cookie;

  try {
    const stored = JSON.parse(localStorage.getItem(FBCLID_STORAGE_KEY) || 'null');
    if(stored && stored.fbclid) {
      return `fb.1.${ stored.ts }.${ stored.fbclid }`;
    }
  } catch(e) { /* ignore */ }
  return '';
}

/**
 * 取得 fbp（FB Browser ID，_fbp cookie）
 */
export function getFbp() {
  return getCookie('_fbp');
}

/**
 * 取得要傳給後端 CAPI 的 Meta 追蹤參數
 */
export function getMetaTracking() {
  return {
    fbp: getFbp(),
    fbc: getFbc(),
  };
}

/**
 * 進階配對：把使用者資料推進 dataLayer，供 GTM 的 FB Pixel 代碼設定進階配對欄位
 * Pixel 的手動進階配對接受未雜湊的原始值，會在瀏覽器端先雜湊再傳送
 * @param {object} contact - { email, phone, firstName, lastName }
 */
export function pushUserDataToDataLayer(contact = {}) {
  if(typeof window === 'undefined' || !window.dataLayer) return;

  const userData = {};
  if(contact.email) userData.em = contact.email.trim().toLowerCase();
  if(contact.phone) {
    // Meta 建議帶國碼、僅數字：台灣手機 09xxxxxxxx → 8869xxxxxxxx
    const digits = contact.phone.replace(/\D/g, '');
    userData.ph = digits.replace(/^0/, '886');
  }
  if(contact.firstName) userData.fn = contact.firstName.trim().toLowerCase();
  if(contact.lastName) userData.ln = contact.lastName.trim().toLowerCase();

  if(Object.keys(userData).length === 0) return;

  window.dataLayer.push({
    event: 'set_user_data',
    user_data: userData,
  });
}
